import * as loginPagesMod from './controls/loginpages';
import * as profilePagesMod from './controls/profilepages';
import * as passwordPagesMod from './controls/passwordpages';
import * as sellYourTicketsWithUsMod from './controls/sellyourticketswithus';
import * as RepresentationTypeMod from './controls/representationtype';
import * as userSessionMod from './controls/usersession';
import * as otherControlsMod from './controls/othercontrols';
import * as cardsSectionMod from './controls/cardssection';
import * as orderHistoryMod from './controls/orderhistory';
import * as emailPasswordModificationMod from './controls/emailpasswordmodification';
import * as searchWidgetMod from './controls/searchwidget';
import * as promoCodeMod from './controls/promocode';
import * as menuMod from './controls/menu';
import * as footerMod from './controls/footer';
import * as productSectionsMod from './controls/productsections';
import * as pointOfSaleListMod from './controls/pointofsalelist';
import * as contactUsMod from './controls/contactus';
import * as utilMod from './util';
import * as modalMod from './controls/modal';
export * from './controls/layout';
export * from './controls/toolbox';
export * from './util';
export * from './types';
export * from './toolkit';
//import * as showsListMod from './controls/showslist';

export const loginPages = loginPagesMod;
export const profilePages = profilePagesMod;
export const passwordPages = passwordPagesMod;
export const sellYourTicketsWithUs = sellYourTicketsWithUsMod;
export const RepresentationType = RepresentationTypeMod;
export const userSession = userSessionMod;
export const otherControls = otherControlsMod;
export const cardsSection = cardsSectionMod;
export const orderHistory = orderHistoryMod;
export const emailPasswordModification = emailPasswordModificationMod;
export const searchWidget = searchWidgetMod;
export const promoCode = promoCodeMod;
export const menu = menuMod;
export const footer = footerMod;
export const productSections = productSectionsMod;
export const pointOfSaleList = pointOfSaleListMod;
export const contactUs = contactUsMod;

/** @deprecated use the direct access instead */
export const util = utilMod;
export const modal = modalMod;

// export const toolbox = toolboxMod;
//export const showsList = showsListMod;

